export { default as SplitButton } from "./split-button";
export type { IProps as ISplitButtonProps } from "./split-button.types";
